var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"course_modal_line"},[_c('li',[_vm._v(_vm._s(_vm.source.order))]),_c('li',[_vm._v(_vm._s(_vm.source.studentName))]),_c('li',[_vm._v(_vm._s(_vm.source.Gpa))])])}
var staticRenderFns = []

export { render, staticRenderFns }